<template>
  <div>
    <div :class="{ 'bg-grey': bgGrey }" class="w-100" style="z-index: -1">
      <div class="container-loading" v-if="loading === true">
        <div class="spinner-border text-primary" v-if="loading === true"></div>
      </div>
      <template v-if="loading === false">
        <div
          class="position-sticky top-0 padding bg-white radius shadow zIndexSetting"
        >
          <slot name="title"></slot>
          <slot name="dropdown"></slot>
        </div>
        <div class="overflow-hidden height-base" :class="{'m-0' : fixedFooter}">
          <slot name="content"></slot>
        </div>
        <slot name="footer-bottom"></slot>
        <div
          :class="`bottom-0 w-100 footer-css ${fixedFooter ? 'position-fixed' : 'position-sticky'} ${footerRadius ? 'footer-radius' : ''}`"
        >
          <slot name="footer"></slot>
        </div>
      </template>
    </div>
    <div>
      <slot name="modal"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "slotBase",
  props: {
    bgGrey: Boolean,
    footerRadius: Boolean,
    loading: Boolean,
    fixedFooter: Boolean,
  },
};
</script>

<style scoped>
.bg-grey {
  background-color: #f2f5f7;
}
.footer-css {
  background-color: #ffffff;
  /* padding: 16px 24px; */
}
.footer-radius {
  border-radius: 16px 16px 0px 0px;
}
.radius {
  border-radius: 0px 0px 16px 16px;
}
.shadow {
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
}
.height-base {
  min-height: 100vh;
  margin-bottom: 90px;
}
.container-loading {
  height: 100vh;
  display: flex;
  width: 100vw;
  z-index: -1;
  place-content: center;
  align-items: center;
}
.zIndexSetting {
  z-index: 3;
}
</style>
